import { useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Hero from "@/sections/Hero";
import Offerings from "@/sections/Offerings";
import MusicSection from "@/sections/MusicSection";
import EventsSection from "@/sections/EventsSection";
import About from "@/sections/About";
import Philosophy from "@/sections/Philosophy";
import Contact from "@/sections/Contact";

export default function Home() {
  const [tracks, setTracks] = useState([]);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/music").then((r) => setTracks(r.data)).catch(() => {});
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <div className="bg-[#f7efe2]">
      <Navbar />
      <Hero />
      <Offerings />
      <MusicSection tracks={tracks} settings={settings} />
      <EventsSection />
      <About />
      <Philosophy />
      <Contact />
      <Footer settings={settings} />
    </div>
  );
}
